import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route pathname changes.
 *
 * React Router preserves scroll position on navigate by default, which
 * is wrong UX for content pages — clicking an admin card and landing
 * mid-page leaves the user disoriented. Mount this once at the top of
 * the router tree.
 *
 * Note: only triggers on PATH change. Hash-only changes (e.g.
 * /video-tours#how-it-works) preserve native browser scroll behaviour
 * so anchor jumps still work.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // `instant` (not `smooth`) — feels like a fresh page rather than a
    // disorienting scroll animation across long content.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
